import { toast } from "react-toastify";
import { RootState, store } from "../../app/store";

export const downloadFile = async (
    url: string,
    fileName: string,
): Promise<void> => {
    const { root } = store.getState() as RootState;
    const { authToken } = root;

    const headers: HeadersInit = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    if (authToken) {
        headers["Authorization"] = `Bearer ${authToken}`;
    }

    const response = await fetch(url, {
        headers,
    }).catch(() => {
        toast.error("Bestand downloaden mislukt");
    });

    if (!response) {
        return;
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};
